export default __webpack_public_path__ + "static/media/MG.e770fd8b.svg";